module.exports = __webpack_public_path__ + "img/16.13c33ce9.jpg";